import React from 'react';

export default function Terms() {
  return (
    <div className="w-full h-auto bg-white ">
      <h1 className="text-2xl font-bold mt-6">Terms and Conditions</h1>
      <p className="mt-4">
        {/* Your terms and conditions content */}
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tincidunt...
      </p>
    </div>
  );
}
